
function Charges() {
    return (
        <div class="page-content">
           hello
        </div>
    );
}

export default Charges;
